// src/api/reporterService.js

import axios from 'axios';
import { API_REPORTER_ENDPOINT } from '../authApi/reporterApi'; // Adjust path if needed

// Helper to get the current token from localStorage
const getToken = () => localStorage.getItem('token');

// Helper to create authorized headers for JSON data
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
    'Content-Type': 'application/json',
  },
});

// Helper to create authorized headers for FormData (e.g., file uploads)
const getAuthHeadersForFormData = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});


export const createNews = async (formData) => {
  try {
    const response = await axios.post(API_REPORTER_ENDPOINT.CREATE_NEWS, formData, getAuthHeadersForFormData());
    return response.data;
  } catch (error) {
    console.error("Error creating news:", error.response?.data || error.message);
    throw error;
  }
};

 export const uploadMediaFiles = async (formData) => {
  try {
    const response = await axios.post(
     API_REPORTER_ENDPOINT.UPLOAD_MEDIA, // endpoint constant
      formData, // FormData object with files
      {
        headers: {
          ...getAuthHeaders().headers, // auth headers if needed
          "Content-Type": "multipart/form-data", // file upload ke liye zaroori
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in uploadMedia:", error.response?.data || error.message);
    throw error;
  }
};




// --- PUBLIC LOOKUP DATA (Categories, Subcategories) ---
// These are public endpoints, accessible without specific role,
// but authentication is still required as per your routes for reporters.
export const getAllCategories = async () => {
  try {
    const response = await axios.get(API_REPORTER_ENDPOINT.GET_ALL_CATEGORIES, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error.response?.data || error.message);
    throw error;
  }
};

export const getAllSubCategories = async (params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_REPORTER_ENDPOINT.GET_ALL_SUBCATEGORIES}${queryString ? `?${queryString}` : ''}`;
    const response = await axios.get(url, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching subcategories:", error.response?.data || error.message);
    throw error;
  }
};

// --- GET REPORTER'S OWN NEWS ---
// export const getMyNews = async (params = {}) => {
//   try {

//     const url = `${API_REPORTER_ENDPOINT.GET_MY_NEWS}`;
//     const response = await axios.get(url, getAuthHeaders());
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching reporter's news:", error.response?.data || error.message);
//     throw error;
//   }
// };

export const getMyNews = async (params = {}) => {
  try {
    // Build query string from params
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_REPORTER_ENDPOINT.GET_MY_NEWS}?${queryString}`;

    const response = await axios.get(url, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching reporter's news:", error.response?.data || error.message);
    throw error;
  }
};

export const updateNews = async (id, data = {}, files = []) => {
  try {
    const url = `${API_REPORTER_ENDPOINT.UPDATE_NEWS}/${id}`;
    const formData = new FormData();

    // text fields
    Object.keys(data).forEach((key) => {
      if (data[key] !== undefined && data[key] !== null) {
        if (Array.isArray(data[key])) {
          formData.append(key, JSON.stringify(data[key]));
        } else {
          formData.append(key, data[key]);
        }
      }
    });

    // files (agar naye image/video add karna ho)
    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append("files", file);
      });
    }

    const response = await axios.put(url, formData, {
      ...getAuthHeaders(),
      headers: {
        ...getAuthHeaders().headers,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error updating news:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Delete news
export const deleteNews = async (id) => {
  try {
    const url = `${API_REPORTER_ENDPOINT.DELETE_NEWS}/${id}`;
    const response = await axios.delete(url, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error deleting news:", error.response?.data || error.message);
    throw error;
  }
};

// export const createShort = async (formData) => {
//   try {
//     const response = await axios.post(
//       API_REPORTER_ENDPOINT.CREATE_SHORT,   // Example: "/api/v1/shorts"
//       formData,
//       {
//         headers: {
//           ...getAuthHeaders(),       // JWT / Authorization headers
//           "Content-Type": "multipart/form-data",
//         },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error creating short:", error.response?.data || error.message);
//     throw error.response?.data || { message: "Failed to create short" };
//   }
// };

// export const createShort = async (formData) => {
//   try {
//     const response = await axios.post(
//       API_REPORTER_ENDPOINT.CREATE_SHORT,
//       formData,
//       {
//         headers: {
//           ...getAuthHeaders(),
//           "Content-Type": "multipart/form-data",
//         },
//       }
//     );
//     return response.data; // already unwrapped
//   } catch (error) {
//     console.error("Error creating short:", error.response?.data || error.message);
//     throw error.response?.data || { message: "Failed to create short" };
//   }
// };

export const createShort = async (formData) => {
  try {
    const response = await axios.post(
      API_REPORTER_ENDPOINT.CREATE_SHORT,
      formData,
      getAuthHeadersForFormData()   // ✅ sirf Authorization bhejega
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create short:", error.response?.data || error.message);
    throw error?.response?.data || { message: "Error creating short" };
  }
};

export const getMyShorts = async (params = {}) => {
  try {
    // Convert params to query string
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_REPORTER_ENDPOINT.GET_MY_SHORTS}?${queryString}`;

    const response = await axios.get(url, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching reporter's shorts:",
      error.response?.data || error.message
    );
    throw error;
  }
};